let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fdSEM")).then(() => parcelRequire('aceGa'));